export const currentUser = {
  id: 'user-1',
  name: 'Mia Jensen',
  username: 'miajensen',
  email: 'mia@email.dk',
}

export const events = [
  {
    id: 'event-1',
    name: 'Mias bryllup 2025',
    date: '2025-06-14',
    color: '#6c63ff',
    ownerName: 'Mia Jensen',
    ownerId: 'user-1',
    members: [
      { id: 'user-1', name: 'Mia Jensen', role: 'owner' },
      { id: 'user-2', name: 'Thomas Kvist', role: 'co-owner' },
      { id: 'user-3', name: 'Sara Andersen', role: 'helper' },
    ],
  },
  {
    id: 'event-2',
    name: "Jonas' 30 år",
    date: '2025-08-07',
    color: '#ff6b6b',
    ownerName: 'Thomas Kvist',
    ownerId: 'user-2',
    members: [
      { id: 'user-2', name: 'Thomas Kvist', role: 'owner' },
      { id: 'user-1', name: 'Mia Jensen', role: 'helper' },
    ],
  },
  {
    id: 'event-3',
    name: 'Sommerfest',
    date: '2025-07-20',
    color: '#06d6a0',
    ownerName: 'Sara Andersen',
    ownerId: 'user-3',
    members: [
      { id: 'user-3', name: 'Sara Andersen', role: 'owner' },
      { id: 'user-1', name: 'Mia Jensen', role: 'helper' },
    ],
  },
]

export const initialTasks = [
  {
    id: 'task-1',
    eventId: 'event-1',
    title: 'Bestil bryllupskage',
    description: 'Kontakt minimum 3 bagerier. 3-lags kage til 80 personer med hindbærmousse og marcipan. Budget: maks 4.500 kr.',
    priority: 'high',
    assignedTo: 'Mia Jensen',
    assignedToId: 'user-1',
    deadline: '2025-05-20',
    orderDate: '2025-05-01',
    price: 4500,
    quantity: 1,
    link: 'https://laglace.dk',
    done: false,
    comments: [
      { id: 'c1', author: 'Thomas Kvist', text: 'Jeg kender en god bager i Aarhus — skal jeg spørge?', time: 'i dag, 09:15' }
    ],
  },
  {
    id: 'task-2',
    eventId: 'event-1',
    title: 'Vælg menu med caterer',
    description: '',
    priority: 'high',
    assignedTo: 'Mia Jensen',
    assignedToId: 'user-1',
    deadline: '2025-05-10',
    done: false,
    comments: [],
  },
  {
    id: 'task-3',
    eventId: 'event-1',
    title: 'Send invitationer til alle gæster',
    description: '',
    priority: 'medium',
    assignedTo: 'Thomas Kvist',
    assignedToId: 'user-2',
    deadline: '2025-05-15',
    done: false,
    comments: [],
  },
  {
    id: 'task-4',
    eventId: 'event-1',
    title: 'Book blomsterdekoratør',
    description: '',
    priority: 'low',
    assignedTo: 'Sara Andersen',
    assignedToId: 'user-3',
    done: true,
    comments: [],
  },
  {
    id: 'task-5',
    eventId: 'event-2',
    title: "Book lokale til Jonas' fest",
    description: '',
    priority: 'high',
    assignedTo: 'Mia Jensen',
    assignedToId: 'user-1',
    deadline: '2025-05-15',
    done: false,
    comments: [],
  },
]

export const initialGuests = {
  'event-1': [
    { id: 'g1', name: 'Anne Larsen', email: 'anne@email.dk', status: 'confirmed', dietary: 'Vegetar', plusOne: true },
    { id: 'g2', name: 'Bjarne Pedersen', email: 'bjarne@email.dk', status: 'confirmed', plusOne: false },
    { id: 'g3', name: 'Camilla Hansen', email: 'camilla@email.dk', status: 'pending', plusOne: true },
    { id: 'g4', name: 'Daniel Nielsen', email: 'daniel@email.dk', status: 'pending', plusOne: false },
    { id: 'g5', name: 'Eva Christensen', email: 'eva@email.dk', status: 'declined', plusOne: false },
  ],
  'event-2': [
    { id: 'g6', name: 'Frederik Møller', email: 'frederik@email.dk', status: 'confirmed', plusOne: true },
  ],
  'event-3': [],
}

export const initialBudget = {
  'event-1': [
    { id: 'bc-1', name: 'Catering', budget: 15000, color: '#ff9f43', bgColor: '#fff3e0', items: [
      { id: 'bi-1', name: 'Gourmet Catering — forret', amount: 3500 },
      { id: 'bi-2', name: 'Gourmet Catering — hovedret', amount: 5500 },
      { id: 'bi-3', name: 'Gourmet Catering — dessert', amount: 3000 },
    ]},
    { id: 'bc-2', name: 'Lokale', budget: 10000, color: '#ff4444', bgColor: '#ffe4e4', items: [
      { id: 'bi-4', name: 'Skovhuset Konferencecenter', amount: 10000 },
    ]},
    { id: 'bc-3', name: 'Blomster', budget: 8000, color: '#06d6a0', bgColor: '#e8fdf5', items: [
      { id: 'bi-5', name: 'Blomsterland — brudbuket', amount: 1200 },
      { id: 'bi-6', name: 'Blomsterland — borddekorationer', amount: 3000 },
    ]},
    { id: 'bc-4', name: 'Foto/video', budget: 10000, color: '#6c63ff', bgColor: '#f0eeff', items: [
      { id: 'bi-7', name: 'Studio Lens — fotografering', amount: 4500 },
      { id: 'bi-8', name: 'Studio Lens — videoclip', amount: 1500 },
    ]},
    { id: 'bc-5', name: 'Musik', budget: 5000, color: '#ffd166', bgColor: '#fff9e0', items: [
      { id: 'bi-9', name: 'DJ-pakke', amount: 2000 },
    ]},
  ],
  'event-2': [
    { id: 'bc-6', name: 'Mad', budget: 5000, color: '#ff9f43', bgColor: '#fff3e0', items: [] },
    { id: 'bc-7', name: 'Lokale', budget: 8000, color: '#ff4444', bgColor: '#ffe4e4', items: [] },
  ],
  'event-3': [
    { id: 'bc-8', name: 'Mad & drikke', budget: 3000, color: '#06d6a0', bgColor: '#e8fdf5', items: [] },
  ],
}

export const initialShopping = {
  'event-1': [
    { id: 's1', name: 'Blomsterkrans til bord', link: 'https://blomsterland.dk', price: 249, quantity: 4, purchased: false },
    { id: 's2', name: 'Bordholder til navnekort', link: 'https://sostrene-grene.dk', price: 45, quantity: 60, purchased: false },
    { id: 's3', name: 'Stearinlys sæt × 24', link: 'https://ilva.dk', price: 189, quantity: 3, purchased: true },
  ],
  'event-2': [],
  'event-3': [],
}

export const initialMeals = {
  'event-1': [
    {
      id: 'meal-1',
      category: 'Forret',
      name: 'Rejecocktail',
      description: 'Klassisk og elegant forret med friske rejer',
      image: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=400&h=300&fit=crop',
      portions: 8,
      price: 180,
      selected: false,
      assignedTo: 'Mia Jensen',
      link: 'https://www.arla.dk/opskrifter/rejecocktail/',
      ingredients: ['300g pillede rejer', '1 citron', '2 spsk remoulade', 'Smørrebrødspapir'],
      steps: ['Bland rejer og remoulade', 'Anret i glas med citronsaft', 'Pynt med citronskive og krybder', 'Server straks'],
      shoppingList: [
        { id: 'sl-1', name: '300g pillede rejer', checked: false },
        { id: 'sl-2', name: '1 citron', checked: false },
        { id: 'sl-3', name: 'remoulade', checked: false },
      ],
    },
    {
      id: 'meal-2',
      category: 'Hovedret',
      name: 'Laksesteak med hollandaisesauce',
      description: 'Saftig laks med cremet sauce og kartofler',
      image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400&h=300&fit=crop',
      portions: 8,
      price: 520,
      selected: false,
      assignedTo: 'Thomas Kvist',
      link: 'https://www.arla.dk/opskrifter/laksesteak/',
      ingredients: ['8 × 180g laksesteak', '4 æggeblommer', '200g smør', '1 citron', 'Salt og peber', 'Dild'],
      steps: ['Skræl kartofler og kog dem', 'Tilbered hollandaisesauce', 'Steg laksesteaks ca. 4-5 min på hver side', 'Server med kartofler og sauce'],
      shoppingList: [
        { id: 'sl-4', name: '8 × 180g laksesteak', checked: false },
        { id: 'sl-5', name: 'Æg (minimum 4 stk)', checked: false },
        { id: 'sl-6', name: 'Smør (minimum 200g)', checked: false },
        { id: 'sl-7', name: 'Kartofler (1,5 kg)', checked: false },
        { id: 'sl-8', name: 'Dild (frisk)', checked: false },
      ],
    },
    {
      id: 'meal-3',
      category: 'Dessert',
      name: 'Chokolademousse med hindbær',
      description: 'Luftig mousse med friske hindbær',
      image: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=400&h=300&fit=crop',
      portions: 8,
      price: 140,
      selected: false,
      assignedTo: 'Sara Andersen',
      link: 'https://www.arla.dk/opskrifter/chokolademousse/',
      ingredients: ['200g mørk chokolade', '4 dl fløde', '2 spsk sukker', '300g hindbær', '1 spsk vanilje'],
      steps: ['Smelt chokoladen i vandbad', 'Pisk fløden stiv', 'Fold chokolade og fløde sammen', 'Del i glas og top med hindbær'],
      shoppingList: [
        { id: 'sl-9', name: '200g mørk chokolade (70%)', checked: false },
        { id: 'sl-10', name: 'Fløde (4 dl)', checked: false },
        { id: 'sl-11', name: 'Hindbær (300g)', checked: false },
        { id: 'sl-12', name: 'Vanilje', checked: false },
      ],
    },
  ],
  'event-2': [
    {
      id: 'meal-4',
      category: 'Hovedret',
      name: 'BBQ Ribsbryst',
      description: 'Mørt ribsbryst med røgfuld BBQ-sauce',
      image: 'https://images.unsplash.com/photo-1588195538326-c5b1e9f80a1b?w=400&h=300&fit=crop',
      portions: 10,
      price: 450,
      selected: false,
      assignedTo: 'Mia Jensen',
      link: '',
      ingredients: ['2 kg ribsbryst', '3 dl BBQ sauce', '2 spsk paprika', 'Salt og peber', 'Øl'],
      steps: ['Gnid ribsbrystet med krydderier', 'Grill ved 120°C i 4 timer', 'Pensling med BBQ sauce sidste time', 'Hvil 10 min før servering'],
      shoppingList: [
        { id: 'sl-13', name: '2 kg ribsbryst', checked: false },
        { id: 'sl-14', name: 'BBQ sauce (3 dl)', checked: false },
        { id: 'sl-15', name: 'Paprika (2 spsk)', checked: false },
      ],
    },
  ],
  'event-3': [],
}

export const invitations = [
  { id: 'inv-1', eventName: 'Julefrokost 2025', eventColor: '#ffd166', eventDate: '2025-12-12', fromName: 'Thomas Kvist' },
]

export function getDaysUntil(dateStr) {
  const today = new Date()
  const target = new Date(dateStr)
  return Math.ceil((target - today) / (1000 * 60 * 60 * 24))
}

export function getInitials(name) {
  return name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()
}

export function formatDate(dateStr) {
  if (!dateStr) return ''
  return new Date(dateStr).toLocaleDateString('da-DK', { day: 'numeric', month: 'long', year: 'numeric' })
}
